import $axios from '@/axios-instance.js'

export const deliveryTemplateService = {
  getListData,
  getAll,
  getById,
  getItemsByDeliveryTemplateId,
  create,
  update,
  delete: _delete
}

function getListData (filter, page) {
  return $axios.get(`${process.env.ROOT_API}/delivery-templates`, { params: Object.assign({ currentPage: page }, filter) }).then(response => {
    return response.data
  })
}

function getAll () {
  return $axios.get(`${process.env.ROOT_API}/delivery-templates/get-all`).then(response => {
    return response.data
  })
}

function getItemsByDeliveryTemplateId (deliveryTemplateId) {
  return $axios.get(`${process.env.ROOT_API}/delivery-templates/items/${deliveryTemplateId}`).then(response => {
    return response.data
  })
}

function getById (id) {
  return $axios.get(`${process.env.ROOT_API}/delivery-templates/${id}`).then(response => {
    return response.data
  })
}

function create (deliveryTemplate) {
  return $axios.post(`${process.env.ROOT_API}/delivery-templates`, deliveryTemplate).then(response => {
    return response.data
  })
}

function update (deliveryTemplate) {
  return $axios.put(`${process.env.ROOT_API}/delivery-templates/${deliveryTemplate.deliveryTemplateId}`, deliveryTemplate).then(response => {
    return response.data
  })
}

function _delete (id) {
  return $axios.delete(`${process.env.ROOT_API}/delivery-templates/${id}`).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/delivery-template.service.js